import { render, staticRenderFns } from "./kucoin.vue?vue&type=template&id=226b097d&"
import script from "./kucoin.vue?vue&type=script&lang=ts&"
export * from "./kucoin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports